import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useParams } from 'react-router-dom';
import Layout from './components/Layout';
import GameLanding from './components/GameLanding';
import games from './data/games';
import RulesBook from './components/RulesBook';
import CountdownTimer from './components/CountdownTimer';
import RemedierCards from './components/RemedierCards';
import Galleri from './components/Galleri';
import './App.css';

// Updated with fullscreen functionality and mobile improvements
function RemedierPage() {
  return (
    <div style={{ textAlign: 'center', marginTop: 60 }}>
      <h1>Remedier</h1>
      <p>This is the Remedier page. Content coming soon!</p>
    </div>
  );
}

function PraktikPage() {
  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: 32 }}>
      <h1>Praktik</h1>
      <div style={{ 
        background: '#f5f5f5', 
        border: '2px dashed #ccc', 
        borderRadius: 12, 
        padding: 60, 
        textAlign: 'center',
        marginBottom: 20
      }}>
        <h2 style={{ color: '#333', marginBottom: 20 }}>Hvem tager hvad med?</h2>
        <p style={{ color: '#666', marginBottom: 30, fontSize: '1.1rem' }}>
          Klik på knappen nedenfor for at åbne arket i Google Sheets
        </p>
        <a 
          href="https://docs.google.com/spreadsheets/d/1bkYa8sMQw9psjlmCpqIh1aHbxFjXy0gu4OTwmD0oEog/edit?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            background: '#4285f4',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: 8,
            textDecoration: 'none',
            fontWeight: 500,
            fontSize: '1.1rem',
            boxShadow: '0 2px 8px rgba(66, 133, 244, 0.3)',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#3367d6';
            e.target.style.transform = 'translateY(-1px)';
            e.target.style.boxShadow = '0 4px 12px rgba(66, 133, 244, 0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#4285f4';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 8px rgba(66, 133, 244, 0.3)';
          }}
        >
          Åbn "Hvem tager hvad med?"
        </a>
      </div>
      <div style={{ color: '#888', fontSize: 14, textAlign: 'center' }}>
        Arket åbner i en ny fane. Du kan redigere direkte i arket hvis du er logget ind og har adgang.
      </div>
    </div>
  );
}

function HallOfFamePage() {
  const winners = [
    { year: 2016, name: 'Martin' },
    { year: 2017, name: 'Mikkel' },
    { year: 2018, name: 'Lyssværdet' },
    { year: 2019, name: 'Kasper' },
    { year: 2020, name: 'Martin' },
    { year: 2021, name: 'Lyssværdet' },
    { year: 2022, name: 'Mikkel' },
    { year: 2023, name: 'Lyssværdet' },
    { year: 2024, name: 'Christian' }
  ];

  return (
    <div style={{
      position: 'relative',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      color: '#fff',
      overflow: 'hidden',
    }}>
      {/* Spotlights fixed to the viewport */}
      <div style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        height: 600,
        zIndex: 0,
        pointerEvents: 'none',
      }}>
        <div className="hof-spotlight hof-spotlight-left" style={{
          position: 'absolute',
          left: 'calc(22% - 40px)',
          bottom: 80,
          width: 80,
          height: 600,
          borderRadius: '60% 60% 100% 100% / 100% 100% 100% 100%',
          background: 'radial-gradient(ellipse at 50% 100%, rgba(255,255,200,0.45) 0%, rgba(255,255,200,0.18) 60%, rgba(255,255,200,0) 100%)',
          filter: 'blur(2.5px)',
          opacity: 0.85,
          pointerEvents: 'none',
          zIndex: 0,
          transformOrigin: '50% 100%',
          animation: 'hof-spotlight-left-rotate 3.5s ease-in-out infinite alternate',
        }} />
        <div className="hof-spotlight hof-spotlight-right" style={{
          position: 'absolute',
          right: 'calc(22% - 40px)',
          bottom: 80,
          width: 80,
          height: 600,
          borderRadius: '60% 60% 100% 100% / 100% 100% 100% 100%',
          background: 'radial-gradient(ellipse at 50% 100%, rgba(255,255,200,0.45) 0%, rgba(255,255,200,0.18) 60%, rgba(255,255,200,0) 100%)',
          filter: 'blur(2.5px)',
          opacity: 0.85,
          pointerEvents: 'none',
          zIndex: 0,
          transformOrigin: '50% 100%',
          animation: 'hof-spotlight-right-rotate 3.5s ease-in-out infinite alternate',
        }} />
      </div>
      {/* All content above spotlights */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ width: '100%', maxWidth: 900, margin: '0 auto' }}>
          {/* Hall of Fame Title with reflection */}
          <h1 
            style={{ 
              fontSize: '4rem', 
              fontWeight: 'bold', 
              marginBottom: 40,
              background: 'none',
              textShadow: '0 0 30px rgba(255, 215, 0, 0.5)',
              position: 'relative',
              overflow: 'visible',
              display: 'block',
              zIndex: 1,
              textAlign: 'center',
              width: '100%',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <span className="hof-title-reflection-text" style={{
              position: 'relative',
              display: 'inline-block',
              background: 'linear-gradient(120deg, #ffd700 0%, #ffd700 44%, rgba(255,255,255,0.85) 48%, rgba(255,255,255,0.85) 52%, #ffd700 56%, #ffd700 100%)',
              backgroundSize: '220% 100%',
              backgroundPosition: '0% 0%',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
              WebkitTextFillColor: 'transparent',
              animation: 'hof-reflection-text-sweep 3.5s cubic-bezier(0.4,0.2,0.2,1) infinite',
              willChange: 'background-position',
              fontWeight: 'bold',
            }}>
              HALL OF FAME 🏆
            </span>
            <style>{`
              @media (max-width: 600px) {
                .hof-title-reflection-text {
                  font-size: 2.2rem !important;
                }
                .hof-spotlight-left, .hof-spotlight-right {
                  top: 0 !important;
                  bottom: auto !important;
                }
              }
              @keyframes hof-reflection-text-sweep {
                0% { background-position: 0% 0%; }
                60% { background-position: 100% 0%; }
                100% { background-position: 100% 0%; }
              }
              @keyframes hof-spotlight-left-rotate {
                0% { transform: rotate(-35deg); }
                50% { transform: rotate(30deg); }
                100% { transform: rotate(-35deg); }
              }
              @keyframes hof-spotlight-right-rotate {
                0% { transform: rotate(35deg); }
                50% { transform: rotate(-30deg); }
                100% { transform: rotate(35deg); }
              }
            `}</style>
          </h1>
        </div>
        {/* Winners List */}
        <div style={{
          display: 'grid',
          gap: 20,
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          position: 'relative',
          zIndex: 1, // winner boxes above spotlights
          maxWidth: 1000,
          margin: '0 auto',
          padding: '32px 16px',
          minHeight: '60vh',
        }}>
          {winners.map((winner, index) => (
            <div key={winner.year}
              style={{
                background: 'linear-gradient(145deg, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.05))',
                border: 'none',
                borderRadius: 20,
                padding: 30,
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                boxShadow: 'none',
                outline: 'none',
                gridColumn: index === winners.length - 1 ? '1 / -1' : 'auto',
                willChange: 'transform',
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-5px) scale(1.02)';
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
              }}
            >
              <div style={{ pointerEvents: 'none' }}>
                {/* Trophy Icon */}
                <div style={{ 
                  fontSize: '3rem', 
                  marginBottom: 15,
                  filter: 'drop-shadow(0 0 10px rgba(255, 215, 0, 0.5))',
                  transition: 'none',
                  transform: 'none',
                }}>
                  🏆
                </div>
                {/* Year */}
                <div style={{ 
                  fontSize: '2.5rem', 
                  fontWeight: 'bold', 
                  color: '#ffd700',
                  marginBottom: 10,
                  textShadow: '0 0 20px rgba(255, 215, 0, 0.5)',
                  transition: 'none',
                  transform: 'none',
                }}>
                  {winner.year}
                </div>
                {/* Winner Name */}
                <div style={{ 
                  fontSize: '2rem', 
                  fontWeight: 'bold',
                  transition: 'none',
                  transform: 'none',
                }}>
                  {winner.name}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route
            path="/"
            element={
              <div className="home-hero-container" style={{ position: 'relative', width: '100%', minHeight: 'calc(100vh - 120px)', marginBottom: '2rem' }}>
                <div className="home-hero-inner" style={{
                  width: '100%',
                  height: '60vh',
                  minHeight: 400,
                  maxHeight: 700,
                  overflow: 'hidden',
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'stretch',
                  justifyContent: 'center',
                  background: '#222',
                }}>
                  <CountdownTimer />
                  <img
                    className="home-hero-image"
                    src="/forside.png"
                    alt="Disc golf julegolf 2025"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center',
                      filter: 'brightness(0.85) contrast(1.1)',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      zIndex: 1,
                    }}
                  />
                  <div className="forside-logo-wrapper">
                    <img
                      src="/forsidelogo.png"
                      alt="JULEGOLF logo"
                      className="forside-logo-img"
                      style={{
                        maxWidth: '260px',
                        width: '70%',
                        margin: 0,
                        display: 'block',
                      }}
                    />
                  </div>
                  <style>{`
                    @media (min-width: 700px) {
                      .forside-logo-wrapper {
                        position: absolute;
                        top: 180px; left: 0; right: 0; bottom: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 2;
                      }
                      .forside-logo-img {
                        max-width: 320px !important;
                        width: 100% !important;
                      }
                    }
                    @media (max-width: 699px) {
                      .forside-logo-wrapper {
                        position: absolute;
                        left: 50%;
                        top: calc(64px - 50px);
                        transform: translateX(-50%);
                        z-index: 2;
                        width: 100%;
                        display: block;
                      }
                    }
                  `}</style>
                </div>
              </div>
            }
          />
          <Route
            path="/game/:gameId"
            element={<GamePage />}
          />
          <Route
            path="/regler"
            element={<RulesBook />}
          />
          <Route
            path="/remedier"
            element={<RemedierCards />}
          />
          <Route
            path="/praktik"
            element={<PraktikPage />}
          />
          <Route
            path="/galleri"
            element={<Galleri />}
          />
          <Route
            path="/hall-of-fame"
            element={<HallOfFamePage />}
          />
        </Routes>
      </Layout>
    </Router>
  );
}

function GamePage() {
  const { gameId } = useParams();
  const game = games.find((g) => g.id === gameId);
  return <GameLanding game={game} />;
}

export default App;
